<div style="display: block">
  <div class="editrow">
    <label for="issue_priority" class="left">new priority: </label>
    <select class="form-control" id="issue_priority" required [(ngModel)]="issue.priority"
      (ngModelChange)="priorityChanged()" name="priority">
      <option *ngFor="let priority of issue_priorities" [value]="priority.id">{{priority.description}}</option>
    </select>
    <label class="for" for="created_by">created by: </label>
    <span id="created_by">{{issue.created_by}}</span>
  </div>
  <div class="editrow">
    <label for="issue_tag" class="left">new tag: </label>
    <select class="form-control" id="issue_priority" [(ngModel)]="issue.issue_tag_id"
      (ngModelChange)="tagChanged()" name="tag">
      <option *ngFor="let tag of issue_tags" [value]="tag.issue_tag_id">{{tag.issue_tag_name}}</option>
    </select>
    <label class="for" for="created_by">new action: </label>
    <select class="form-control" id="issue_priority" [(ngModel)]="issue.issue_action_id"
      (ngModelChange)="actionChanged()" name="action">
      <option *ngFor="let action of issue_tag_actions" [value]="action.issue_action_id">{{action.issue_action_name}}</option>
    </select>
    <label class="for" for="created_by">follow up: </label>
    <select class="form-control"  id="issue_followup" [(ngModel)]="issue.customer_followup"
      (change)="followupChanged()" name="followup" >
      <option [value]="true">Yes</option>
      <option [value]="false">No</option>
    </select>
  </div>
  <ng-container *ngIf="!!issue.description; else nodesc">
    <div class="editrow">
      <label class="left" for="issue_title">title: </label>
      <input #title [(ngModel)]="issue.title" (ngModelChange)="titleChanged()" placeholder="title" id="issue_title" />
    </div>
    <div class="editrow">
      <label class="left" for="issue_description" id="description_label">description: </label>
      <textarea #description [(ngModel)]="issue.description" (ngModelChange)="descriptionChanged()"
        placeholder="description" rows="4" id="issue_description"></textarea>
      <div class="panel"><button mat-raised-button color="primary" (click)="save()"
          [disabled]="!hasChanges">Save</button></div>
    </div>
  </ng-container>
  <ng-template #nodesc>
    <div class="editrow">
      <label class="left" for="issue_title">description: </label>
      <textarea #title [(ngModel)]="issue.title" (ngModelChange)="titleChanged()"
        placeholder="A description of the issue" rows="4" id="issue_title"></textarea>
      <div class="panel"><button mat-raised-button color="primary" (click)="save()"
          [disabled]="!hasChanges">Save</button></div>
    </div>
  </ng-template>
  <div class="editrow">
    <label class="left" id="issue_actions_label">actions: </label>
    <issue-actions id="issue_actions_component" [hub]="hub" [issue]="issue" [action_types]="action_types"
      [issue_statuses]="issue_statuses" (action_saved)="onActionSaved($event)"></issue-actions>
  </div>
</div>
